import { GRID_LINE, SpreadsheetHeaderRow } from "./TransactionSpreadsheetRow";

const ROW_GRID =
  "grid grid-cols-[minmax(0,1fr)_2.5rem_minmax(0,1fr)] items-stretch";

export function UnreconciledColumnHeaders() {
  return (
    <div
      className={`${ROW_GRID} shrink-0 border-b ${GRID_LINE} bg-slate-50/50`}
    >
      <div className={`min-w-0 border-r ${GRID_LINE}`}>
        <SpreadsheetHeaderRow />
      </div>
      <div
        className={`flex items-center justify-center border-r ${GRID_LINE} text-xs font-medium text-slate-400`}
        aria-hidden
      >
        ✓
      </div>
      <div className="min-w-0">
        <SpreadsheetHeaderRow />
      </div>
    </div>
  );
}

export { ROW_GRID };
